/**
 * BackToTopButton.jsx
 * Created by Destin Frasier 03/06/18
 */

import React from 'react';

import * as Icons from './icons/Icons';
import { scrollToY } from '../../helpers/scrollToHelper';

export default class BackToTopButton extends React.Component {
    constructor(props) {
        super(props);
        this.handleScroll = this.handleScroll.bind(this);
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    setBackToTopBtnPositionBottom() {
        this.recButtonBackToTop.style.bottom = '400px';
    }

    setBackToTopBtnPosition() {
        this.recButtonBackToTop.style.bottom = null;
    }

    hideBackToTopBtn() {
        this.recButtonBackToTop.style.display = 'none';
    }

    showBackToTopBtn() {
        this.recButtonBackToTop.style.display = null;
    }

    handleScroll() {
        const windowHeight = 'innerHeight' in window ? window.innerHeight : document.documentElement.offsetHeight;
        const body = document.body;
        const html = document.documentElement;
        const scrollY = window.pageYOffset || document.documentElement.scrollTop;
        const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
        const windowBottom = windowHeight + window.pageYOffset;

        if (scrollY <= 100) {
            this.hideBackToTopBtn();
        }
        else {
            this.showBackToTopBtn();
        }

        if (windowBottom >= docHeight - 250) {
            this.setBackToTopBtnPositionBottom();
        }
        else {
            this.setBackToTopBtnPosition();
        }
    }

    // Scroll UP
    pressedButton() {
        const pageTop = document.getElementsByClassName('nav-header-placeholder')[0];

        const sectionTop = pageTop.offsetTop - 10;
        scrollToY(sectionTop, 700);
    }

    render() {
        return (
            <button
                className="rec-button-back-to-top"
                ref={(div) => {
                    this.recButtonBackToTop = div;
                }}
                title="Back to top"
                aria-label="Back to top"
                onClick={this.pressedButton.bind(this)}>
                <Icons.IconChevronUp />
                <span>TOP</span>
            </button>
        );
    }
}
